import * as Sentry from '@sentry/nuxt'

export default defineNuxtPlugin({
  name: 'sentry-context',
  order: 20, // after auth-session.client.ts
  setup() {
    const user      = useSupabaseUser()
    const authStore = useAuthStore()

    // Keep Sentry's user/clinic context in sync with auth across login, logout and
    // superadmin impersonation. UUIDs only — never PII (G-UX-007). A one-shot app:mounted
    // hook could miss async Supabase auth resolution on fresh loads, so watch instead.
    watch(user, (val) => {
      if (!val?.id) {
        Sentry.setUser(null)
        return
      }
      Sentry.setUser({ id: val.id })
      // Mirror useUXAnalytics.ts: impersonated_clinic_id takes precedence over the profile clinic.
      const activeClinicId = (val as any)?.app_metadata?.impersonated_clinic_id
        ?? authStore.clinicId
      if (activeClinicId) {
        Sentry.setTag('clinic_id', activeClinicId)
      }
    }, { immediate: true })
  },
})
